import { apiClient } from '@/lib/api-client'

const API_BASE = '/api/v1'

export interface SalesPoint { date: string; quantity: number; revenue: number }
export interface ChangeEvent {
  id: string
  timestamp: string
  event_type: 'image' | 'text'
  channel_id: string | null
  source_type: string | null
  version_number: number | null
  slot: number | null
  block_type: string | null
  diff_summary: string | null
}

export interface SalesSeriesParams { from?: string; to?: string; channelId?: string }
export interface ChangeEventsParams { from?: string; to?: string; channelId?: string; types?: string[] }

export async function getProductSalesSeries(productId: string, p: SalesSeriesParams = {}): Promise<SalesPoint[]> {
  const q = new URLSearchParams()
  if (p.from) q.set('from', p.from)
  if (p.to) q.set('to', p.to)
  if (p.channelId) q.set('channel_id', p.channelId)
  const res = await apiClient.get<{ success: boolean; series: SalesPoint[] }>(
    `${API_BASE}/products/${productId}/sales-series?${q.toString()}`,
  )
  return res.data.series ?? []
}

export async function getProductChangeEvents(productId: string, p: ChangeEventsParams = {}): Promise<ChangeEvent[]> {
  const q = new URLSearchParams()
  if (p.from) q.set('from', p.from)
  if (p.to) q.set('to', p.to)
  if (p.channelId) q.set('channel_id', p.channelId)
  if (p.types?.length) q.set('types', p.types.join(','))
  const res = await apiClient.get<{ success: boolean; events: ChangeEvent[] }>(
    `${API_BASE}/products/${productId}/change-events?${q.toString()}`,
  )
  return res.data.events ?? []
}
